import { createContext, useContext } from 'react';

type VanityLinkModalContextType = {
	openModal: () => void;
	closeModal: () => void;
};

const VanityLinkModalContext = createContext<VanityLinkModalContextType>({
	openModal: () => {},
	closeModal: () => {},
});

export const useVanityLinkModalContext = () => useContext(VanityLinkModalContext);

export { VanityLinkModalContext };
export type { VanityLinkModalContextType };
